import { render, staticRenderFns } from "./Upload-Document-ID.html?vue&type=template&id=db2faa56&scoped=true&external"
import script from "./Upload-Document-ID.js?vue&type=script&lang=js&external"
export * from "./Upload-Document-ID.js?vue&type=script&lang=js&external"
import style0 from "./Upload-Document-ID.scss?vue&type=style&index=0&id=db2faa56&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2faa56",
  null
  
)

export default component.exports